import React from 'react';
import "./style.css"

export default function Con_Pend_MT() {
    return(
        <>
            <div id = "top_Con_Pend_MT">
                <p id = "Con_Pend_MT_Header">Consulta Pendente</p>
            </div>

            <div id = "Main_Con_Pend_MT">
                <button id = "button_Con_Pend_MT">Voltar</button>
                <p id="Con_Pend_MT_Title">Informações da Consulta</p>
                <hr id="divider-Con_Pend_MT" />
                <p id = "Con_Pend_MT_Info">Nome do Paciente</p>
                <p id = "Con_Pend_MT_Content">Nome do Paciente</p>
                <p id = "Con_Pend_MT_Info">Especialidade do Médico Requisitada</p>
                <p id = "Con_Pend_MT_Content">Especialidade do Médico Requisitada</p>
                <p id = "Con_Pend_MT_Info">Data e Hora da Consulta</p>
                <p id = "Con_Pend_MT_Content">dd/mm/aaaa 00:00</p>
                <p id = "Con_Pend_MT_Info">Observações</p>
                <p id = "Con_Pend_MT_Content">Observações</p>
            </div>
            <div id = "buttons_Con_Pend_MT">
                <button id ="button_Con_Pend_MT">Confirmar</button>
                <button id ="button_Con_Pend_MT">Recusar</button>
            </div>
        </>
    )
}